import { gql, type TypedDocumentNode } from '@apollo/client';
import styled from 'styled-components';

import { Target } from '@sorare/core/src/atoms/icons/Target';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandXXS } from '@sorare/core/src/atoms/typography/index.tsx';
import { RewardConfigImage } from '@sorare/core/src/components/rewards/AnyRewardConfig/RewardConfigImage';
import { RewardConfigText } from '@sorare/core/src/components/rewards/AnyRewardConfig/RewardConfigText/index.tsx';

import type { TooltipContent_anyRewardConfigInterface } from './__generated__/index.graphql.ts';

const Separator = styled.span`
  width: 1px;
  height: var(--intermediate-unit);
  background: var(--c-nd-150);
  margin: 0 4px;
`;
const Strikethrough = styled.span`
  text-decoration: line-through;
  color: var(--c-nd-400);
`;

type Props = {
  target: number;
  showTargetValue: boolean;
  hasReducedThreshold: boolean;
  oldThreshold: number | null;
  rewardConfig?: TooltipContent_anyRewardConfigInterface;
};
export const TooltipContent = ({
  target,
  showTargetValue,
  hasReducedThreshold,
  oldThreshold,
  rewardConfig,
}: Props) => {
  return (
    <Horizontal gap={0.5}>
      {!!rewardConfig && (
        <RewardConfigImage anyRewardConfig={rewardConfig} size={3} />
      )}
      {!showTargetValue && !!rewardConfig && (
        <BrandXXS>
          <RewardConfigText anyRewardConfig={rewardConfig} />
        </BrandXXS>
      )}
      {!!rewardConfig && <Separator />}
      <Target />{' '}
      {!!showTargetValue && (
        <BrandXXS>
          {target}&nbsp;
          {!!hasReducedThreshold && (
            <Strikethrough>{oldThreshold}</Strikethrough>
          )}
        </BrandXXS>
      )}
    </Horizontal>
  );
};

TooltipContent.fragments = {
  anyRewardConfigInterface: gql`
    fragment TooltipContent_anyRewardConfigInterface on AnyRewardConfigInterface {
      id
      ...RewardConfigImage_anyRewardConfigInterface
      ...RewardConfigText_anyRewardConfigInterface
    }
    ${RewardConfigImage.fragments.anyRewardConfigInterface}
    ${RewardConfigText.fragments.anyRewardConfigInterface}
  ` as TypedDocumentNode<TooltipContent_anyRewardConfigInterface>,
};
